// Helper to format transaction amount with sign
export const formatTransactionAmount = (
  balance: number,
  product: string,
  formatCurrency: (amount: number, currency: string) => string | undefined,
  forceNegative?: boolean,
  forcePositive?: boolean,
  numberOnly?: boolean
): string => {
  const isCredit = forcePositive || (!forceNegative && balance && balance > 0);
  const amount = balance || 0;
  const formattedAmount =
    formatCurrency(Math.abs(amount), product) ||
    `${Math.abs(amount)} ${product}`;

  if (numberOnly) {
    return formattedAmount;
  }

  return isCredit ? `+${formattedAmount}` : `-${formattedAmount}`;
};
